import ClosePopUpButton from "../../ClosePopUpButton/ClosePopUpButton";
import { useContextValue } from '../../../context/context';
import { CoupleIcon } from "../../../assets/cardIcons";
import './style.css';

//? Temporary data
const gendersData = ["Egal", "Mann", "Frau", "Gay", "Lesbian", "Bisexual", "Transgender", "Asexual", "Agender"];

const GenderPopUp = ({ onClose }) => {
	const { setGender, filledCards, setFilledCards } = useContextValue();
	const handleGender = (gender) => {
		setGender(gender);

		const newCard = { content: gender, isSelected: true, title: "Geshlecht", backgroundColor: "#5A9B59", icon: CoupleIcon };
		const existingCardIndex = filledCards.findIndex(card => card.title === newCard.title);

		if (existingCardIndex !== -1) {
			// Якщо картка існує, створюємо новий масив з оновленою карткою
			const updatedCards = [...filledCards];
			updatedCards[existingCardIndex] = newCard;
			setFilledCards(updatedCards);
		} else {
			// Якщо картки немає, додаємо нову
			setFilledCards([...filledCards, newCard]);
		}

		onClose();
	}

	return (
		<div className="gender-popup">
				<div className="gender-options">
					{
						gendersData.map((gender, index) => <p key={index} onClick={() => handleGender(gender)} className="hourlyRate-option">{gender}</p>)
					}
				</div>
			<ClosePopUpButton onClose={onClose} />
		</div>
	)
}

export default GenderPopUp